import dayjs from 'dayjs';

export const DATE_RANGE_PRESET_IDS = {
    YESTERDAY: 'yesterday',
    LAST_WEEK: 'last-week',
    LAST_MONTH: 'last-month',
};

/**
 * Shared preset options for date range pickers.
 */
export const DATE_RANGE_PRESETS = [
    {
        id: DATE_RANGE_PRESET_IDS.YESTERDAY,
        label: 'Yesterday',
        getRange: () => {
            const yesterday = dayjs().subtract(1, 'day').startOf('day');
            return {
                startDate: yesterday.toDate(),
                endDate: yesterday.toDate(),
            };
        },
    },
    {
        id: DATE_RANGE_PRESET_IDS.LAST_WEEK,
        label: 'Last Week',
        getRange: () => ({
            startDate: dayjs().subtract(6, 'day').startOf('day').toDate(),
            endDate: dayjs().startOf('day').toDate(),
        }),
    },
    {
        id: DATE_RANGE_PRESET_IDS.LAST_MONTH,
        label: 'Last Month',
        getRange: () => ({
            startDate: dayjs().subtract(29, 'day').startOf('day').toDate(),
            endDate: dayjs().startOf('day').toDate(),
        }),
    },
];

export const getDateRangePresetById = (presetId) =>
    DATE_RANGE_PRESETS.find((preset) => preset.id === presetId);

export const formatDateRangeLabel = (startDate, endDate) => {
    const dayCount = dayjs(endDate).diff(dayjs(startDate), 'day') + 1;
    return `${dayCount} day${dayCount === 1 ? '' : 's'}`;
};

export const formatDisplayDate = (date) => dayjs(date).format('MMM D, YYYY');

export const getDateRangePresetIdFromRange = (startDate, endDate) => {
    if (!startDate || !endDate) {
        return null;
    }

    const matchedPreset = DATE_RANGE_PRESETS.find((preset) => {
        const { startDate: presetStart, endDate: presetEnd } = preset.getRange();
        return dayjs(startDate).isSame(presetStart, 'day')
            && dayjs(endDate).isSame(presetEnd, 'day');
    });

    return matchedPreset?.id || null;
};

export const buildDateRangeFromPreset = (presetId) => {
    const preset = getDateRangePresetById(presetId);

    if (!preset) {
        return null;
    }

    const { startDate, endDate } = preset.getRange();

    return {
        startDate,
        endDate,
        rangeLabel: preset.label,
        dateRangePreset: preset.id,
    };
};

export const buildDateRangeState = (startDate, endDate) => {
    const presetId = getDateRangePresetIdFromRange(startDate, endDate);

    if (presetId) {
        return buildDateRangeFromPreset(presetId);
    }

    return {
        startDate,
        endDate,
        rangeLabel: formatDateRangeLabel(startDate, endDate),
        dateRangePreset: null,
    };
};
